<template>
  <div>
    <div v-if="!loading">
      <NumberFormGroup
          :value="value.limit"
          name="limit"
          label="Limit"
          :error="(errors.limit || [])[0]"
          help-text="The number of items to display."
          @input="emit('limit', $event)"
      />

      <SelectFormGroup
          :value="value.portal_id"
          name="portal_id"
          label="Portal"
          :error="(errors.portal_id || [])[0]"
          :options="portalOptions"
          help-text="The portal to display articles from."
          @input="emit('portal_id', $event)"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {NumberFormGroup, RadioFormGroup, SelectFormGroup,TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },
  },

  data() {
    return {
      portals: null,

      shared: store,
      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    portalOptions() {
      return this.portals.map(portal => {
        return {
          value: portal.id,
          label: portal.attributes.name
        }
      })
    }
  },

  methods: {
    load() {
      http.get('/api/v2/portals').then(response => {
        this.portals = response.data.data

        this.loading = false
      })
    },

    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
